import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
import { ContentCard } from '../components/ContentCard';
import { SplitIcon, ArrowUpIcon, Volume2Icon, ShieldCheckIcon } from 'lucide-react';
const laws = [{
  icon: SplitIcon,
  title: 'Lane Splitting is ILLEGAL',
  description: 'Unlike California, Michigan prohibits lane splitting entirely. Riding between lanes of traffic—even in stopped traffic—is illegal and can result in a ticket. This applies to all roads and highways.',
  variant: 'warning' as const
}, {
  icon: ArrowUpIcon,
  title: 'Handlebar Height Restrictions',
  description: "Michigan law restricts handlebar height. Your handlebars cannot be higher than your shoulders when you're seated on the motorcycle. Ape hangers that exceed this limit are illegal.",
  variant: 'warning' as const
}, {
  icon: Volume2Icon,
  title: 'Modified Exhaust Restrictions',
  description: 'Michigan has strict noise limits for motorcycle exhausts. Modified or aftermarket exhausts that exceed noise limits can result in citations. Stock exhaust systems are always compliant.',
  variant: 'warning' as const
}, {
  icon: ShieldCheckIcon,
  title: 'Insurance Requirements for No Helmet',
  description: 'To ride without a helmet in Michigan, you must carry at least $20,000 in first-party medical benefits coverage. This is in addition to meeting age and experience requirements.',
  variant: 'important' as const
}];
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0
  }
};
export function HorribleLaws() {
  return <div className="min-h-screen bg-[#0a0a0a] safe-bottom" data-id="element-254">
      <PageHeader title="4 Horrible MI Laws" subtitle="Laws every Michigan biker should know" data-id="element-255" />

      <main className="px-4 py-6" data-id="element-256">
        {/* Intro */}
        <motion.div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-2xl p-4 mb-6" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} data-id="element-257">
          <p className="text-[#a3a3a3] text-sm leading-relaxed" data-id="element-258">
            Michigan has some motorcycle laws that frustrate riders.
            Understanding these laws helps you stay legal and avoid costly
            tickets.
          </p>
        </motion.div>

        <motion.div className="space-y-4" variants={container} initial="hidden" animate="show" data-id="element-259">
          {laws.map((law, index) => <motion.div key={index} variants={item} data-id="element-260">
              <ContentCard icon={law.icon} title={law.title} description={law.description} variant={law.variant} data-id="element-261" />
            </motion.div>)}
        </motion.div>

        {/* Know Your Rights */}
        <motion.div className="mt-6 bg-[#d4a853]/10 border border-[#d4a853]/30 rounded-2xl p-4" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} data-id="element-262">
          <p className="text-[#d4a853] font-semibold mb-2" data-id="element-263">Got a Ticket?</p>
          <p className="text-[#a3a3a3] text-sm" data-id="element-264">
            If you've been cited for any of these violations, contact us. We may
            be able to help reduce or dismiss your ticket.
          </p>
        </motion.div>
      </main>
    </div>;
}